<template>
    <div class="row">
        <div class="col-12 mb-1">
            <div class="alert alert-warning mb-0">
                <div class="alert-body">
                    Burada yapılan değişilik günlük puantaj yok ise oluştur var ise günceller. Gün kontrol edilip kaydedilmelidir.
                </div>
            </div>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Personel</label>
            <v-select-list v-model="employee" :options="employees" label="FullName" v-on:search="searchEmployees" placeholder="Personel" :loading="employeeLoading"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Tarih</label>
            <v-date-picker v-model="value.Date" placeholder="Tarih"></v-date-picker>
        </div>
        <div class="col-12">
            <label class="form-label">Çalışma Türü</label>
            <select class="form-control" v-model="value.EmployeeWorkingTypeId">
                <option :value="null">Seçiniz</option>
                <option v-for="type in types" :key="type.Code" :value="type.Id">{{type.Name}}</option>
            </select>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'

export default {
    props:{
        value:Object,
        types:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        return {
            employeeLoading:false,
            employees:[],
        }
    },
    methods:{
        searchEmployees(search){
            if(search){
                this.employeeLoading = true
                EmployeeOperationsApi.Employee.Search(search)
                .then(res=>{
                    this.employees = res.data.Data
                    this.employeeLoading = false
                }).catch(err=>{ 
                    this.employeeLoading = false 
                })
            }
        },
    },
    computed:{
        employee:{
            get:function(){
                return this.employees.find(s=>s.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
    }
}
</script>

<style>

</style>